import classNames from 'classnames';

export function DetailCardHeaderElements({ children }) {
  return <ul className="w-full border-b-2 border-mystic-500 mb-2 flex">{children}</ul>;
}

export function Item({ children, active = false, onCheck, isButton = true, blockType = false }) {
  if (isButton) {
    return (
      <li>
        <button
          className={classNames(
            "flex flex-col pl-3.75 pt-4 pb-3 pr-3 relative text-left border-mystic-500 border-r h-full w-[213px] before:content-[''] before:w-full before:h-[2px] before:absolute before:-bottom-[2px] before:left-0 before:block",
            {
              'before:bg-dodger-blue-500 cursor-default': active,
              'hover:before:bg-dodger-blue-300': !active,
            },
          )}
          onClick={() => onCheck()}
        >
          {children}
        </button>
      </li>
    );
  }

  return (
    <li
      className={classNames({
        'flex-1': !blockType,
      })}
    >
      <div
        className={classNames('flex flex-col pl-3.75 pt-4 pb-3 pr-3 relative text-left h-full', {
          'border-mystic-500 border-r w-[213px]': blockType,
          'w-full': !blockType,
        })}
      >
        {children}
      </div>
    </li>
  );
}

function Title({ children }) {
  return <div className="text-header-5 text-lynch-500 w-full">{children}</div>;
}

function Content({ children }) {
  return <div className="w-full text-2xl text-black-pearl-500">{children}</div>;
}

DetailCardHeaderElements.Title = Title;
DetailCardHeaderElements.Item = Item;
DetailCardHeaderElements.Content = Content;
